"use client";

import LanguageSwitcher from "@/components/LanguageSwitcher";
import { ShareButton } from "@/components/ShareResults";
import WizardFooter from "@/components/WizardFooter";
import WizardProgressBar from "@/components/WizardProgressBar";
import { ROUTE_INTRO } from "@/utils/router_utils";
import { usePathname } from "next/navigation";
import { useEffect, useMemo, useState } from "react";

export default function ClientWizardLayout({
  locale,
  tenant,
  version,
  totalSteps,
  children,
}: {
  locale: string;
  tenant: string;
  version: string;
  totalSteps: number;
  children: React.ReactNode;
}) {
  console.log(
    "*** WIZARD version layout client called! ",
    locale,
    tenant,
    version
  );

  // Default to step 1, actual step will be determined in client component
  const [currentStep, setCurrentStep] = useState("0");
  const [currentAction, setCurrentAction] = useState("");

  const pathname = usePathname();

  useEffect(() => {
    console.log("*** pathname changed", pathname);
    const paths = pathname.split("/");
    if (paths.length >= 5) {
      setCurrentAction(paths[4]);
      if (paths[4] === 'steps' && paths.length >= 6) {
        setCurrentStep(paths[paths.length - 1]);
      }
    }
  }, [pathname]);

  const shareLink = useMemo(() => {
    if (typeof window !== "undefined") {
      return `${window.location.origin}${ROUTE_INTRO(locale, tenant, version)}`;
    }
    return "";
  }, [locale, tenant, version]);

  return (
    <div className="wizard-container h-screen grid justify-center">
      {currentStep && currentAction != "results" && (
        <div className="wizard-header">
          <div className="absolute top-0 right-0 2xl:right-8 hidden md:flex">
            <LanguageSwitcher size="xl" />
            <ShareButton className="hidden md:block" link={shareLink} isOnlyIcon={false} />
          </div>
          <WizardProgressBar
            currentStep={parseInt(currentStep)}
            totalSteps={totalSteps}
            locale={locale}
          />
        </div>
      )}

      <main className="wizard-content flex">
        <div className="wizard-content-center">
          {children}
        </div>
      </main>
      {currentStep && currentAction != "results" && (
        <WizardFooter locale={locale} />
      )}
    </div>
  );
}
